module.exports = __webpack_public_path__ + "img/modern.f194501c.png";